import { useQuery } from '@tanstack/react-query';

import { getProgramFollows } from '@/modules/library/domain/resources/getProgramFollows';

export const useProgramFollows = () => {
  const {
    data: programsFollowed,
    refetch,
    error,
    isLoading,
  } = useQuery({
    queryKey: ['follow'],
    queryFn: getProgramFollows,
    staleTime: Infinity,
  });

  return { refetch, programsFollowed, error, isLoading };
};
